import type { Components } from '@mui/material/styles';

export default function MuiFormControl(): Components['MuiFormControl'] {
  return {};
}
